var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[(_vm.title)?_c('a',{staticClass:"link-external",attrs:{"href":_vm.marketplaceURL,"target":"about:blank"}},[_c('base-field',{attrs:{"title":_vm.title,"icon":"link"}})],1):_c('span',[_vm._v(" — ")])])}
var staticRenderFns = []

export { render, staticRenderFns }